<div id="fontLoader" style="position: absolute; visibility:hidden"></div>
<div #component id="mainDiv"><template #playercontainer></template></div>
<div *ngIf="state!='signage' && state!=''" class="signPlayer">SignPlayer</div>
<app-check-is-installed *ngIf="state=='checkInstalled'" #checkInstalledPage></app-check-is-installed>
<install-pwa *ngIf="state=='install'" #installPage></install-pwa>
<app-close *ngIf="state=='close'" #closePage></app-close>
<app-check-internet-connection *ngIf="state=='checkInternet'" #checkInternetPage></app-check-internet-connection>
<app-host-server *ngIf="state=='host'" #hostPage></app-host-server>
<app-remote-registration *ngIf="state=='remoteReg'" #remoteRegPage></app-remote-registration>
<app-login *ngIf="state=='login'" #loginPage></app-login>
<app-registration *ngIf="state=='registration'" #registrationPage></app-registration>
<app-taskbar style="position: absolute; left: 0; top: 0;"></app-taskbar>



